import React, { useEffect, useState } from "react";
import {
  BrandAutoComplete,
  Head,
  Loading,
  UserAutocomplete,
} from "../../components";
import Pagination from "react-js-pagination";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import moment from "moment-jalaali";
import MenuItem from "@material-ui/core/MenuItem";
import Api from "../../utils/api";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import AccordionActions from "@material-ui/core/AccordionActions";
import { Box, CircularProgress } from "@material-ui/core";
import "react-modern-calendar-datepicker/lib/DatePicker.css";
import DatePicker from "react-modern-calendar-datepicker";
import "./allFile.css";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import { toast } from "react-toastify";
import Autocomplete from "@material-ui/lab/Autocomplete/Autocomplete";

var jalaali = require("jalaali-js");

const AllFile = (props) => {
  const history = useHistory();
  const location = useLocation();
  const role = useSelector((state) => state.authReducer.user.role.id);
  const queryString = require("query-string");

  const query = queryString.parse(location.search);

  useEffect(() => {
    new Api().get(`/backend/roles/evaluator/users`).then((res) => {
      if (typeof res !== "undefined") {
        findSelectedEvaluator(res);
      }
    });
  }, []);

  const calender = (date) => {
    let splitDate = date?.split("/");
    let join = {};
    join.year = +splitDate?.[0];
    join.month = +splitDate?.[1];
    join.day = +splitDate?.[2];
    return join;
  };

  const handleFile = () => {
    setLoading(true);
    let obj = {
      ...query,
      id,
      from_date: (fromDate && shamsiToMiladi(fromDate)) || null,
      to_date: toDate && shamsiToMiladi(toDate),
      op: "all",
    };
    new Api()
      .post(`/backend/insurance/damage/excel_bak`, obj)
      .then((res) => {
        if (typeof res !== "undefined") {
          if (res.status) {
            setLoading(false);
            window.open(res.link.replace("http", "https"));
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        throw err;
      });
  };

  const shamsiToMiladi = (value) => {
    let y;
    y =
      value && jalaali.toGregorian(value["year"], value["month"], value["day"]);
    let date = y && Object.values(y).join("/");

    return date;
  };

  const condition = [
    { status: 2, title: "رد درخواست" },
    { status: 3, title: "در حال بررسی" },
    { status: 4, title: "تکمیل شده" },
    { status: 5, title: "نقص مدارک" },
    { status: 6, title: "ارجاع به ارزیاب" },
    { status: 7, title: "ارجاع به کارشناس" },
    { status: 10, title: "ارجاع به بیمه گر" },
    { status: 11, title: "بایگانی" },
  ];

  const [loading, setLoading] = useState(false);
  const [evaluator, setEvaluator] = useState(query.evaluator || null);
  const [evaluatorList, setEvaluatorList] = useState([]);
  const [data, setData] = useState();
  const [city, setCity] = useState(query.city || null);
  const [insurance, setInsurance] = useState(query.insurance_type || -1);
  const [mobile, setMobile] = useState(query.mobile || null);
  const [status, setStatus] = useState(query.status || -1);
  const [referId, setReferId] = useState(query.refer_id || -1);
  const [fromDate, setFromDate] = useState(
    (query.from_date && calender(query.from_date)) || null,
  );
  const [toDate, setToDate] = useState(
    (query.to_date && calender(query.to_date)) || null,
  );
  const [receiver, setReceiver] = useState(query.receiver || -1);
  const [page, setPage] = useState(parseInt(query.page) || 1);
  const [loop, setloop] = useState(1);
  const [id, setId] = useState(query.id || -1);
  const [deleteFileModal, setDeleteFileModal] = useState(false);
  const [limit, setLimit] = useState(parseInt(query.limit) || 50);
  const [loadingId, setLoadingId] = useState(null);
  const [mainLoading, setMainLoading] = useState(false);
  const [defaultEvaluator, setDefaultEvaluator] = useState(null);
  const [cityList, setCityList] = useState(null);
  const [defaultCity, setDefaultCity] = useState(null);

  useEffect(() => {
    handleRequest();
  }, []);

  useEffect(() => {
    if (data?.last_page < query.page) handleRequest("page", 1);
  }, [data]);

  useEffect(() => {
    setCity(query.city);
  }, [query]);

  useEffect(() => {
    new Api().get("/region").then((res) => {
      setCity(res);
      convertCity(res);
    });
  }, []);

  const convertCity = (city) => {
    let arr = [];
    for (let i = 0; i < city?.length; i++) {
      for (let j = 0; j < city?.[i]?.children?.length; j++) {
        arr.push({
          id: city?.[i]?.children[j]?.id,
          value: city?.[i]?.children[j]?.title,
        });
      }
    }
    findSelectedCity(arr);
    setCityList(arr);
  };

  const findSelectedEvaluator = (def) => {
    let select =
      def &&
      def?.find((item) => {
        return +item.id === +evaluator;
      });
    setDefaultEvaluator(select);
    setEvaluatorList(def);
  };

  const findSelectedCity = (def) => {
    let select =
      def &&
      def?.find((item) => {
        return +item.id === +city;
      });
    setDefaultCity(select);
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modal: {
      display: "flex",
      padding: theme.spacing(1),
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: 400,
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  }));
  const classes = useStyles();

  const deleteFile = (id) => {
    setLoading(true);
    new Api()
      .delete(`/backend/insurance/damage/${id}`)
      .then((res) => {
        if (res.status) {
          handleRequest();
        }
      })
      .catch((err) => {
        throw err;
      });
  };

  const handleRequest = (name, value) => {
    // setMainLoading(true)
    const modifiedQuery = {
      ...query,
      [name]:
        name === "from_date" || name === "to_date"
          ? Object.values(value).reverse().join("/")
          : value,
    };
    for (const key of Object.keys(modifiedQuery)) {
      if (modifiedQuery[key] === "") {
        delete modifiedQuery[key];
      }
    }
    history.replace({
      pathname: location.pathname,
      search: queryString.stringify(modifiedQuery),
    });

    if (name === "mobile" || name === "id") {
      clearTimeout(loop);
      setloop(
        setTimeout(() => {
          new Api()
            .get(`/backend/insurance/damage`, {
              receiver: +query.receiver || +receiver || -1,
              op: "all",
              refer_id: +query.refer_id || +referId || -1,
              status: +query.status || +status || -1,
              insurance_type: +query.insurance_type || +insurance || -1,
              evaluator: +query.evaluator || -1,
              city: +query.city || +city || -1,
              from_date: (fromDate && shamsiToMiladi(fromDate)) || -1,
              to_date: (toDate && shamsiToMiladi(toDate)) || -1,
              injured: -1,
              mobile: +query.mobile || +mobile || -1,
              page: parseInt(query.page) || 1,
              id: +query.id ?? +id ?? -1,
              limit: +query.limit || +limit,
              [name]:
                name === "from_date" || name === "to_date"
                  ? shamsiToMiladi(value)
                  : value || -1,
            })
            .then((res) => {
              setMainLoading(false);
              setLoading(false);
              setDeleteFileModal(false);

              if (typeof res !== "undefined") {
                if (res.status || typeof res.status === "undefined") {
                  setData(res);
                }
              }
            })
            .catch((err) => {
              setMainLoading(false);
              setLoading(false);
              setDeleteFileModal(false);

              throw err;
            });
        }, 1000),
      );
    } else {
      new Api()
        .get(`/backend/insurance/damage`, {
          receiver: +query.receiver || +receiver || -1,
          refer_id: +query.refer_id || +referId,
          status: +query.status || +status || -1,
          insurance_type: +query.insurance_type || +insurance || -1,
          evaluator: +query.evaluator || -1,
          city: +query.city || +city || -1,
          injured: -1,
          op: "all",
          mobile: +query.mobile || +mobile || -1,
          page: parseInt(query.page) || 1,
          id: +query.id || +id || -1,
          limit: +query.limit || +limit,
          from_date: (fromDate && shamsiToMiladi(fromDate)) || -1,
          to_date: (toDate && shamsiToMiladi(toDate)) || -1,
          [name]:
            name === "from_date" || name === "to_date"
              ? shamsiToMiladi(value)
              : value || -1,
        })
        .then((res) => {
          setMainLoading(false);
          setLoading(false);
          setDeleteFileModal(false);

          if (typeof res !== "undefined") {
            if (res.status || typeof res.status === "undefined") {
              setData(res);
            }
          }
        })
        .catch((err) => {
          setMainLoading(false);
          setLoading(false);
          setDeleteFileModal(false);
          throw err;
        });
    }
  };
  const _makeQueryStringParams = async (name, value) => {
    switch (name) {
      case "insurance_type":
        await setInsurance(value);
        break;
      case "evaluator":
        await setEvaluator(value);
        break;
      case "mobile":
        await setMobile(value);
        break;
      case "status":
        setStatus(value);
        break;
      case "from_date":
        setFromDate(value);
        break;
      case "to_date":
        setToDate(value);
        break;
      case "receiver":
        setReceiver(value);
        break;
      case "refer_id":
        setReferId(value);
        break;
      case "page":
        setPage(value);
        break;
      case "city":
        setCity(value);
        break;
      case "limit":
        setLimit(value);
        break;
      case "id":
        setId(value);
        break;
    }
    await handleRequest(name, value);
  };

  const handleStatus = (status) => {
    switch (parseInt(status)) {
      case -1:
        return "انتخاب";
      case 0:
        return "ارجاع  به اپراتور";
      case 2:
        return "رد درخواست";
      case 3:
        return "در حال بررسی";
      case 4:
        return "تکمیل شده";
      case 5:
        return "نقص مدارک";
      case 6:
        return "ارجاع به ارزیاب";
      case 7:
        return "ارجاع به کارشناس";
      case 8:
        return "ارجاع به  کارشناس نهایی";
      case 10:
        return "ارجاع به بیمه گر";
      case 13:
        return "ارجاع به بیمه گر";
    }
  };

  return (
    <>
      {mainLoading && !loading ? (
        <div
          style={{
            display: "flex",
            minHeight: "500px",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </div>
      ) : (
        <div style={{ padding: "0 20px" }}>
          <Box style={{ margin: "20px 0" }} boxShadow={0}>
            <Accordion defaultExpanded={false}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1c-content"
                id="panel1c-header"
              >
                <div>
                  <Typography>جستجو</Typography>
                </div>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={4} md={3}>
                    <UserAutocomplete
                      name={"کاربر قبلی"}
                      onChange={(value) =>
                        _makeQueryStringParams("receiver", value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <UserAutocomplete
                      name={"کاربر فعلی"}
                      onChange={(value) =>
                        _makeQueryStringParams("refer_id", value)
                      }
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      select
                      label="رشته"
                      value={insurance}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      name="insurance"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) => {
                        _makeQueryStringParams(
                          "insurance_type",
                          event.target.value,
                        );
                      }}
                    >
                      <MenuItem key={-1} value={-1}>
                        انتخاب
                      </MenuItem>
                      <MenuItem key={2} value={2}>
                        بدنه
                      </MenuItem>
                      <MenuItem key={1} value={1}>
                        ثالث
                      </MenuItem>
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    {((evaluatorList && !query.evaluator) ||
                      (evaluatorList && defaultEvaluator)) && (
                      <Autocomplete
                        onChange={(event, value) => {
                          _makeQueryStringParams("evaluator", value?.id);
                          setDefaultEvaluator({ value: value?.id });
                        }}
                        defaultValue={defaultEvaluator}
                        options={evaluatorList}
                        getOptionLabel={(option) =>
                          option.name + " " + option.family
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            margin={"dense"}
                            label={"ارزیاب"}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    )}
                  </Grid>

                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      select
                      label="وضعیت"
                      value={status}
                      variant="outlined"
                      margin="dense"
                      fullWidth
                      name="insurance"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      onChange={(event) => {
                        _makeQueryStringParams("status", event.target.value);
                      }}
                    >
                      <MenuItem key={-1} value={-1}>
                        انتخاب
                      </MenuItem>
                      {condition &&
                        condition.map((item) => {
                          return (
                            <MenuItem key={item.status} value={item.status}>
                              {item.title}
                            </MenuItem>
                          );
                        })}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    {cityList && (
                      <Autocomplete
                        onChange={(event, value) => {
                          _makeQueryStringParams("city", value?.id);
                        }}
                        defaultValue={defaultCity}
                        options={cityList}
                        getOptionLabel={(option) => option.value}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            fullWidth
                            margin={"dense"}
                            label={"شهر"}
                            variant="outlined"
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        )}
                      />
                    )}
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      margin="dense"
                      label="کد پرونده"
                      name="id"
                      fullWidth
                      value={id}
                      onChange={(event) => {
                        _makeQueryStringParams("id", event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <TextField
                      id="outlined-basic"
                      variant="outlined"
                      margin="dense"
                      label="موبایل"
                      name="mobile"
                      fullWidth
                      value={mobile}
                      onChange={(event) => {
                        _makeQueryStringParams("mobile", event.target.value);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <div className={"date_detail"}>
                      <div className={classes.root}>
                        <div
                          style={{ width: "100%" }}
                          className="datepicker-input-container"
                        >
                          <DatePicker
                            inputPlaceholder={"از تاریخ"}
                            value={fromDate}
                            onChange={(value) =>
                              _makeQueryStringParams("from_date", value)
                            }
                            shouldHighlightWeekends
                            locale="fa" // add this
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                  <Grid item xs={12} sm={4} md={3}>
                    <div className={"date_detail"}>
                      <div className={classes.root}>
                        <div
                          style={{ width: "100%" }}
                          className="datepicker-input-container"
                        >
                          <DatePicker
                            inputPlaceholder={"تا تاریخ"}
                            value={toDate}
                            onChange={(value) =>
                              _makeQueryStringParams("to_date", value)
                            }
                            shouldHighlightWeekends
                            locale="fa" // add this
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </AccordionDetails>
              <Divider />
              <AccordionActions>
                <Button size="small" color="primary">
                  جستجو
                </Button>
              </AccordionActions>
            </Accordion>
          </Box>

          <Head data={{ link: "/", title: "گزارش گیری از کلیه پرونده ها" }} />
          <Grid container>
            <Grid item xs={6}>
              <TextField
                select
                value={limit}
                margin="dense"
                InputLabelProps={{
                  shrink: true,
                }}
                onChange={(event) => {
                  setLimit(event.target.value);
                  _makeQueryStringParams("limit", event.target.value);
                }}
              >
                <MenuItem value="50">50</MenuItem>
                <MenuItem value="100">100</MenuItem>
                <MenuItem value="200">200</MenuItem>
              </TextField>
            </Grid>
            <Grid justifyContent={"center"} item xs={6}>
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  onClick={() => {
                    handleFile();
                  }}
                  variant="contained"
                  color="primary"
                >
                  {!loading ? (
                    "گزارش گیری"
                  ) : (
                    <CircularProgress color={"secondary"} size={20} />
                  )}
                </Button>
              </div>
            </Grid>
          </Grid>
          <div style={{ overflowX: "auto" }}>
            <table className="table">
              <thead>
                <tr>
                  <th>ردیف</th>
                  <th>شماره پرونده</th>
                  <th>رشته</th>
                  <th>بیمه گذار</th>
                  <th>موبایل بیمه گذار</th>
                  <th>زمان وقوع حادثه</th>
                  <th>شهر وقوع حادثه</th>
                  <th>آدرس</th>
                  <th>کاربر فعلی</th>
                  <th>وضعیت</th>
                  <th>تعیین وضعیت</th>
                </tr>
              </thead>
              <tbody>
                {typeof data !== "undefined" &&
                  data &&
                  data.data &&
                  data.data.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.id}</td>
                        <td>{item.insurance_type?.title}</td>
                        <td>
                          {item.injured?.name + " " + item.injured?.family}
                        </td>
                        <td>{item.injured?.mobile}</td>
                        {item.date_occurrence.includes("1400") ? (
                          <td>
                            {item.time_occurrence +
                              " -- " +
                              moment(item.date_occurrence).format("YYYY/M/D")}
                          </td>
                        ) : (
                          <td>
                            {item.time_occurrence +
                              " -- " +
                              moment(item.date_occurrence).format(
                                "jYYYY/jM/jD",
                              )}
                          </td>
                        )}
                        <td>{item.city.title}</td>
                        <td>{item.address_occurrence}</td>
                        <td>{`${item.operator?.name} ${item.operator && item.operator?.family}`}</td>

                        <td>{handleStatus(item.status)}</td>
                        <td>
                          <ButtonGroup
                            color="primary"
                            aria-label="outlined primary button group"
                          >
                            {role !== "call_center" && (
                              <Button
                                onClick={() => {
                                  history.push(`/khesarat/${item.id}`, {
                                    item,
                                  });
                                }}
                              >
                                مشاهده
                              </Button>
                            )}

                            <Button
                              onClick={() => {
                                history.push(`/references/${item.id}`, {
                                  item,
                                });
                              }}
                            >
                              ارجاعات
                            </Button>
                            {/*{*/}
                            {/*    role === "super_admin" &&*/}
                            {/*    <Button onClick={() => {*/}
                            {/*        setDeleteFileModal(item.id)*/}
                            {/*    }}>*/}
                            {/*        حذف*/}
                            {/*    </Button>*/}
                            {/*}*/}
                          </ButtonGroup>
                          <div className={classes.root}>
                            <Modal
                              disablePortal
                              disableEnforceFocus
                              disableAutoFocus
                              open={deleteFileModal === item.id}
                              onClose={() => {
                                setDeleteFileModal(false);
                              }}
                              aria-labelledby="server-modal-title"
                              aria-describedby="server-modal-description"
                              className={classes.modal}
                              // container={() => rootRef.current}
                            >
                              <div className={classes.paper}>
                                <h2 id="server-modal-title">
                                  آیا از ادامه عملیات مطمئن هستید ؟
                                </h2>
                                <ButtonGroup
                                  color="primary"
                                  aria-label="outlined primary button group"
                                >
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                      setLoadingId(item.id);
                                      deleteFile(item.id);
                                    }}
                                  >
                                    {loading && deleteFileModal === item.id ? (
                                      <CircularProgress />
                                    ) : (
                                      "بله"
                                    )}
                                  </Button>
                                  <Button
                                    color="primary"
                                    onClick={() => {
                                      setDeleteFileModal(false);
                                    }}
                                  >
                                    خیر
                                  </Button>
                                </ButtonGroup>
                              </div>
                            </Modal>
                          </div>
                        </td>
                        {/*<td>*/}
                        {/*    <ButtonGroup color="primary" aria-label="outlined primary button group">*/}
                        {/*        <Button onClick={() => {setLoadingId(item.id) ; handleArchive(item.id)}}>*/}
                        {/*            {(loading && item.id === loadingId) ? <CircularProgress/> :  "بازگردانی"}*/}
                        {/*        </Button>*/}
                        {/*    </ButtonGroup>*/}
                        {/*</td>*/}
                      </tr>
                    );
                  })}
              </tbody>
            </table>
          </div>
          {data && data.data && data.data.length > 0 && (
            <Pagination
              activePage={+query.page || 1}
              itemsCountPerPage={data && data.per_page}
              totalItemsCount={data && data.total}
              pageRangeDisplayed={5}
              onChange={(page) => _makeQueryStringParams("page", page)}
            />
          )}
        </div>
      )}
    </>
  );
};

export default AllFile;
